import { render, staticRenderFns } from "./OnlineClassManageStudents.vue?vue&type=template&id=ae8b75b0&scoped=true&"
import script from "./OnlineClassManageStudents.vue?vue&type=script&lang=js&"
export * from "./OnlineClassManageStudents.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClassManageStudents.vue?vue&type=style&index=0&id=ae8b75b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b75b0",
  null
  
)

export default component.exports